import React, { ButtonHTMLAttributes } from 'react';

type LoaderButtonProps = {
  isLoading: boolean;
  text: string;
  loadingText: string;
  className?: string;
  disabled?: boolean;
};

const LoaderButton: React.FC<
  LoaderButtonProps & ButtonHTMLAttributes<HTMLButtonElement>
> = ({
  isLoading,
  text,
  loadingText,
  className = '',
  disabled = false,
  ...props
}) => (
  <button
    className={`c-btn ${className}`}
    disabled={disabled || isLoading}
    {...props}
  >
    <div className="c-btn__inner">
      {isLoading && (
        <i
          className="fal fa-spinner-third spinning u-margin-right-small"
          title={loadingText}
        />
      )}
      {!isLoading ? text : loadingText}
    </div>
  </button>
);

export default LoaderButton;
